import React from 'react';
import { arrayOf, func, shape, string } from 'prop-types';
import classnames from 'classnames';
import { Select } from 'jl-design-system/components/select/Select';

import styles from './PartnersGroupsDropdown.scss';

export const PartnersGroupsDropdown = ({
  partnersGroups,
  selectedPartnersGroupId,
  onChange,
  className,
}) => (
  <div
    data-testid="PartnersGroupsDropdown"
    className={classnames(styles.PartnersGroupsDropdown, className)}
  >
    <p className={styles.Label}>Stylist level</p>
    <Select
      id="chosen-partners-group"
      name="chosen-partners-group"
      value={selectedPartnersGroupId}
      className={styles.Select}
      onChange={({ target }) => onChange(partnersGroups.find((group) => group.id === target.value))}
      disabled={partnersGroups.length === 1}
    >
      {partnersGroups.map((group) => (
        <option key={group.id} value={group.id}>
          {`${group.name} • ${group.price}`}
        </option>
      ))}
    </Select>
  </div>
);

export const MemoizedPartnersGroupsDropdown = React.memo(PartnersGroupsDropdown);

PartnersGroupsDropdown.propTypes = {
  partnersGroups: arrayOf(
    shape({
      id: string,
      name: string,
      price: string,
    }),
  ).isRequired,
  selectedPartnersGroupId: string.isRequired,
  onChange: func,
  className: string,
};
